import type {
  NotificationPreferenceGroup,
  NotificationTemplateCategory,
} from '../types/interfaces/notification-admin';

export function preferenceGroupsForCategory(
  category: NotificationTemplateCategory,
): NotificationPreferenceGroup[] {
  if (category === 'marketing') return ['marketing'];
  return ['system', 'social', 'reminder'];
}

export function isCategoryPreferenceConsistent(
  category: NotificationTemplateCategory,
  preferenceGroup: NotificationPreferenceGroup,
): boolean {
  return preferenceGroupsForCategory(category).includes(preferenceGroup);
}
